// Заглушка закрытого контента — деревянный «?» в стиле игровых ассетов
// (assets-game/raw/meta/meta-locked-question.png). Один ассет на все замки
// меты: коллекция, карта уровней, достижения.
//
// ВАЖНО при перевыкладке веб-копии: даунскейлить до 640px по ширине
//   magick assets-game/raw/meta/meta-locked-question.png -resize 640x \
//     -quality 92 -strip web/public/assets/meta/locked-question.png
// Исходник 1376×768 в памяти — 4 МБ независимо от веса файла (битмап =
// ш × в × 4 Б), а рисуется он в кружке максимум 77 CSS px и в тумбе коллекции
// ~176 CSS px. С полноразмерным исходником iPhone под нагрузкой выбрасывал
// декодированные спрайты — на карте гасли арт участка и кнопки уровней
// (2026-07-30). 640px взяты по самой крупной сцене с запасом на DPR 3.

export const LOCKED_ART = '/assets/meta/locked-question.png';
